import {
  ERROR_COLORS,
  INFO_COLORS,
  PRIMARY_COLORS,
  SUCCESS_COLORS
} from 'asterX-UIkit'
import * as status from 'constants/statuses'

export const moduleAsterX = [
  { id: 'Авто', name: 'Авто' },
  {
    id: 'Печать ценников',
    name: 'Печать ценников'
  },
  { id: 'Авто выкуп', name: 'Авто выкуп' },
  { id: 'CarFin', name: 'CarFin' },
  {
    id: 'Авто ключница',
    name: 'Авто ключница'
  },
  { id: 'ППП', name: 'ППП' },
  {
    id: 'Редактор технического состояния',
    name: 'Редактор технического состояния'
  },
  { id: 'Гарантии АМП', name: 'Гарантии АМП' },
  { id: 'Платежи выкупа', name: 'Платежи выкупа' },
  { id: 'Продажы АМП', name: 'Продажы АМП' },
  { id: 'Фин. сервис контракты', name: 'Фин. сервис контракты' },
  { id: 'CarFin', name: 'CarFin' },
  { id: 'BipiumX', name: 'BipiumX' },
  { id: 'ППО', name: 'ППО' },
  { id: 'ППО приемка', name: 'ППО приемка' },
  { id: 'Суперсет', name: 'Суперсет' },
  { id: 'Продажа Новые авто', name: 'Продажа Новые авто' },
  { id: 'Комиссия', name: 'Комиссия' },
  { id: 'Дэшборд', name: 'Дэшборд' },
  { id: 'Сайт Aster.kz', name: 'Сайт Aster.kz' },
  { id: 'WIKI', name: 'WIKI' },
  { id: 'Доверенности', name: 'Доверенности' },
  { id: 'Админка ДЦ на сайте', name: 'Админка ДЦ на сайте' },
  { id: 'QR', name: 'QR' },
  { id: 'ArabaX', name: 'ArabaX' },
  { id: 'Шины АМП', name: 'Шины АМП' },
  { id: 'QR охраны', name: 'QR охраны' }
]

export const typeSeoList = [
  { id: 'Ошибка', name: 'Ошибка' },
  { id: 'Киоск', name: 'Киоск' },
  { id: 'Экран', name: 'Экран' },
  { id: 'Звук', name: 'Звук' }
]

export const colorStatusesByCode = code => {
  const colors = {
    [status.NEW_STATUS]: {
      backgroundColor: PRIMARY_COLORS[50],
      color: PRIMARY_COLORS[700],
      border: `1px solid ${PRIMARY_COLORS[200]}`
    },
    [status.IN_PROGRESS_STATUS]: {
      backgroundColor: INFO_COLORS[50],
      color: INFO_COLORS[700],
      border: `1px solid ${INFO_COLORS[200]}`
    },
    [status.EXECUTED_STATUS]: {
      backgroundColor: SUCCESS_COLORS[50],
      color: SUCCESS_COLORS[700],
      border: `1px solid ${SUCCESS_COLORS[200]}`
    },
    [status.CANCEL_STATUS]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[700],
      border: `1px solid ${ERROR_COLORS[200]}`
    },
    [status.DECLINED_STATUS]: {
      backgroundColor: ERROR_COLORS[50],
      color: ERROR_COLORS[700],
      border: `1px solid ${ERROR_COLORS[200]}`
    }
  }

  return colors?.[code] || {}
}

export const getStatusText = text => {
  switch (text) {
    case status.NEW_STATUS:
      return 'Мы уже занимаемся решением вашего запроса'
    case status.IN_PROGRESS_STATUS:
      return 'Мы уже занимаемся решением вашего запроса'
    case status.EXECUTED_STATUS:
      return 'Ваша заявка успешно завершена! Пожалуйста, поделитесь вашим отзывом с нами'
    case status.CANCEL_STATUS:
      return 'Заявка отменена. При необходимости вы можете возобновить заявку'
    case status.DECLINED_STATUS:
      return 'Заявка отменена. При необходимости вы можете возобновить заявку'
    default:
      return '-'
  }
}

export const getModuleText = text => {
  switch (text) {
    case 'Авто продажа':
      return 'Номер РЛ'
    case 'Фин. сервис контракты':
      return 'Номер РЛ'
    case 'Продажа Новые авто':
      return 'Номер РЛ'
    case 'Продажы АМП':
      return 'Номер РЛ'
    case 'C2C сделки':
      return 'Номер РЛ'
    case 'Авто выкуп':
      return 'Номер оценки'
    case 'CarFin':
      return 'Номер кредитной заявки'
    default:
      return '-'
  }
}
export const getFileName = url => {
  return url?.substring(url?.lastIndexOf('/') + 1)
}
